import OutlineCard from '@/organisms/cards/OutlineCard';
import SurveysList from '@/organisms/surveys/SurveysList';

const SurveysListCard = ({ surveys }) => {
  return (
    surveys && (
      <OutlineCard margin={3}>
        <SurveysList surveys={surveys} />
      </OutlineCard>
    )
  );
};
export default SurveysListCard;
